export default ({ COLORS }) => ({
  provider: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    lineHeight: '18px'
  },
  iconHolder: {
    backgroundColor: '#ccc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    color: '#fff',
    borderRadius: '40px',
    marginRight: '8px',
    opacity: '0.6'
  },
  icon: {
    width: '16px',
    height: '16px'
  },
  delete: {
    color: COLORS.RED.FADED,
    cursor: 'pointer',
    marginLeft: '8px'
  }
})
